var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "#D9D9D9",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.469,
    cy: 11.481,
    r: 10.387,
    fill: "#00344E",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.586 8.23 5.621 3.245-5.621 3.245V8.23Z",
    stroke: "#D9D9D9"
  })));
};
export { SvgPlayButton as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMyAyMyIgZmlsbD0iI0Q5RDlEOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTEuNDY4NSIgY3k9IjExLjQ4MTQiIHI9IjEwLjM4NjciIGZpbGw9IiMwMDM0NEUiIHN0cm9rZT0iI0Q5RDlEOSIvPgo8cGF0aCBkPSJNOS41ODU1OSA4LjIyOTE2TDE1LjIwNzMgMTEuNDc0OEw5LjU4NTU5IDE0LjcyMDVMOS41ODU1OSA4LjIyOTE2WiIgZmlsbD0iI0Q5RDlEOSIgc3Ryb2tlPSIjRDlEOUQ5Ii8+Cjwvc3ZnPgo=";